// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { PagePageLinksRepoService } from '@client/app/services/api/pages/page-links-repo.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'page-details-section-inventory-dashboard',
    standalone: false,
    template: `
        <div class="page-details-section-inventory-dashboard">
            <div class="d-flex align-items-center mt-3">
                <span class="fa-2x fa-fw mr-2 text-link" [ngClass]="['MENUES', 'INVENTORY'] | monIcons"></span>
                <div>
                    <h2 class="font-weight-300 my-0" translate>Inventory</h2>
                </div>
            </div>
            <mon-spinner [loading]="loading">
                <div class="row mt-6">
                    <div class="col-30">
                        <div class="card panel-monsido-card">
                            <div class="card-header">
                                <h2 class="card-title font-weight-300" translate>Content</h2>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-stretch">
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         role="button"
                                         [attr.aria-label]="'Images' | translate"
                                         tabindex="0"
                                         (click)="goToSection('image')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'CONTENT_IMAGES'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>Images</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{imageCount | monNumber}}
                                            </p>
                                        </div>
                                        <span class="vertical-ruler vertical-ruler-right vertical-ruler-1 bg-grey d-none d-sm-block"></span>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'Incoming links' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('incominglinks')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'CONTENT_LINKS'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>Incoming Links</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{incomingLinkCount | monNumber}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'Outgoing Links' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('links')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'CONTENT_LINKS'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>Outgoing Links</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{outgoingLinkCount | monNumber}}
                                            </p>
                                        </div>
                                        <span class="vertical-ruler vertical-ruler-right vertical-ruler-1 bg-grey d-none d-sm-block"></span>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'PDF Documents' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('pdf')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'CONTENT_PDF'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>PDF Documents</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{pdfCount | monNumber}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'Excel Documents' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('spreadsheet')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'TECHNICAL_SPREADSHEET'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>Excel Documents</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{excelCount | monNumber}}
                                            </p>
                                        </div>
                                        <span class="vertical-ruler vertical-ruler-right vertical-ruler-1 bg-grey d-none d-sm-block"></span>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'Text Documents' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('document')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'CONTENT_DOCUMENTS'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>Text Documents</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{documentCount | monNumber}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-18">
                        <div class="card panel-monsido-card">
                            <div class="card-header">
                                <h2 class="card-title font-weight-300" translate>Technical</h2>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-stretch">
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'CSS' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('css')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'TECHNICAL_CSS'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>CSS</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{cssCount | monNumber}}
                                            </p>
                                        </div>
                                        <span class="vertical-ruler vertical-ruler-right vertical-ruler-1 bg-grey d-none d-sm-block"></span>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'Javascript' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('js')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'TECHNICAL_JS'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>Javascript</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{jsCount | monNumber}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'Frames' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('frame')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'TECHNICAL_FRAME'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>Frames</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{frameCount | monNumber}}
                                            </p>
                                        </div>
                                        <span class="vertical-ruler vertical-ruler-right vertical-ruler-1 bg-grey d-none d-sm-block"></span>
                                    </div>
                                    <div class="col-48 col-sm-24 d-flex align-items-center mb-6 inv-module"
                                         [attr.aria-label]="'IFrames' | translate"
                                         role="button"
                                         tabindex="0"
                                         (click)="goToSection('iframe')">
                                    <span class="fa-3x fa-fw text-link"
                                          [ngClass]="['SIDEMENUES', 'INVENTORY', 'TECHNICAL_IFRAME'] | monIcons">
                                    </span>
                                        <div class="pl-5">
                                            <p class="text-grey" translate>IFrames</p>
                                            <p class="font-size-1-75 font-weight-300">
                                                {{iframeCount | monNumber}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mon-spinner>
        </div>
    `,
})
export class PageDetailsSectionInventoryDashboardComponent implements OnInit {
    @Input() page: any;
    @Output() onGoToSection = new EventEmitter<any>();

    incomingLinkCount = 0;
    imageCount = 0;
    outgoingLinkCount = 0;
    pdfCount = 0;
    excelCount = 0;
    documentCount = 0;
    cssCount = 0;
    jsCount = 0;
    frameCount = 0;
    iframeCount = 0;
    slideCount = 0;
    loading = true;

    constructor (
        private pageRepoService: PageRepoService,
        private pagePageLinksRepoService: PagePageLinksRepoService,
    ) {}

    ngOnInit (): void {
        this.setupData();
    }

    setupData (): void {
        const promises = [
            this.getIncomingLinks(),
            this.getLinks('image'),
            this.getLinks('link'), // External
            this.getLinks('pdf'),
            this.getLinks('spreadsheet'),
            this.getLinks('document'),
            this.getLinks('css'),
            this.getLinks('js'),
            this.getLinks('frame'),
            this.getLinks('iframe'),
            this.getLinks('slide'),
        ];

        forkJoin(promises).subscribe({
            next: (values: any[]) => {
                this.incomingLinkCount = parseInt(values[0].total);
                this.imageCount = parseInt(values[1].total);
                this.outgoingLinkCount = parseInt(values[2].total);
                this.pdfCount = parseInt(values[3].total);
                this.excelCount = parseInt(values[4].total);
                this.documentCount = parseInt(values[5].total);
                this.cssCount = parseInt(values[6].total);
                this.jsCount = parseInt(values[7].total);
                this.frameCount = parseInt(values[8].total);
                this.iframeCount = parseInt(values[9].total);
                this.slideCount = parseInt(values[10].total);
            },
            error: () => {
                // Handle error if needed
            },
            complete: () => {
                this.loading = false;
            },
        });
    }

    goToSection (section: string): void {
        this.onGoToSection.emit({ section: section });
    }

    private getIncomingLinks (): any {
        const params = {
            page_size: 1,
            page: 1,
        };
        return this.pageRepoService.getIncomingLinks(this.page.id, params).catch(() => {
            return { total: 0 };
        });
    }

    private getLinks (type: string): any {
        const params = {
            type: type,
            page_size: 1,
            page: 1,
        };
        return this.pagePageLinksRepoService.getAll(this.page.id, params).catch(() => {
            return { total: 0 };
        });
    }
}
